import { render, staticRenderFns } from "./retreat.vue?vue&type=template&id=632bbf00&scoped=true&"
import script from "./retreat.vue?vue&type=script&lang=js&"
export * from "./retreat.vue?vue&type=script&lang=js&"
import style0 from "./retreat.vue?vue&type=style&index=0&id=632bbf00&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632bbf00",
  null
  
)

export default component.exports